import React from 'react';
import getName from '../../../helpers/getName';

const typeFlat = {
  FLAT: 3, // квартира
  STORAGE: 5, // кладовка
  OFFICE: 7, // офис
};

export const getDocOptionsSelect = (data = [], isFlat = false) => {
  if (!Array.isArray(data)) return [];

  return data?.map((item) => ({
    ...item,
    key: item.id,
    value: item.id || item.name,
    content:
      `${
        isFlat &&
        (item.typeId === typeFlat.FLAT ||
          item.typeId === typeFlat.STORAGE ||
          item.typeId === typeFlat.OFFICE)
          ? item.typeShortName
          : ''
      } ${item.name} ` || String(item.id),
    search: item.name || String(item.id),
  }));
};

export const getDocOptionsOrgsSelect = (data = []) => {
  if (!Array.isArray(data)) return [];

  return data?.map((org) => {
    const { inn, director, name } = org;

    const search =
      (inn ? inn : '') + ' ' + name + ' ' + (director ? director : '');

    const content = (
      <div>
        {inn && (
          <span style={{ color: '#1aa0d6', fontSize: '12px', marginRight: 8 }}>
            {inn}
          </span>
        )}
        <span>{name}</span>
        {director && (
          <span
            style={{
              fontSize: '11px',
              marginLeft: 8,
              color: '#19867d',
              fontStyle: 'italic',
            }}
          >
            ( {director} )
          </span>
        )}
      </div>
    );

    return {
      ...org,
      key: org.id,
      value: org.id || org.name,
      content,
      search,
      text: org.name,
    };
  });
};

export const getDocOptionsSelectStreet = (data = []) => {
  if (!Array.isArray(data)) return [];

  return data?.map((item) => {
    const city = item.city || null;

    let option = item.name;

    if (city) {
      option = (
        <div>
          <div
            style={{
              lineHeight: 1.1,
              fontSize: 10,
              fontWeight: 700,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {city}
          </div>
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {item.name}
          </div>
        </div>
      );
    }

    return {
      ...item,
      key: item.id,
      value: item.id || item.name,
      content: option || String(item.id),
      search: item.name || String(item.id),
      text: item.name || String(item.id),
    };
  });
};

export const getDocOptionsWorkersSelect = (workers = []) => {
  if (!Array.isArray(workers)) return [];

  return workers?.map((worker) => {
    const name = getName(worker);
    const speciality = worker.specialityName || worker.speciality;

    let option = name;

    if (speciality) {
      option = (
        <div>
          <div
            style={{
              lineHeight: 1.1,
              fontSize: 10,
              fontWeight: 700,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {speciality}
          </div>
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {name}
          </div>
        </div>
      );
    }

    return {
      ...worker,
      key: worker.id,
      value: worker.id,
      content: option || worker.id,
      search: name || worker.id,
      text: name || worker.id,
    };
  });
};
